// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".InstagramGrid{width:100%;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));grid-auto-flow:row dense;grid-gap:1.5rem;gap:1.5rem;margin-bottom:7.5rem;}@media (min-width: 800px){.InstagramGrid{grid-template-columns:repeat(3,minmax(0,1fr));grid-gap:2rem;gap:2rem;margin-bottom:160px}}.InstagramGrid__link{display:block;cursor:pointer}.InstagramGrid__image{border-radius:10px;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
